export default __webpack_public_path__ + "i18n/translation-bn.eeae4c3c.json";